module.exports = __webpack_public_path__ + "img/cloud10.e6566d58.png";